import React, { useState } from 'react';
import i18n from './i18n';
import { withNamespaces } from 'react-i18next';

const LanguageModal = ({ t, onClose }) => {
  const [selectedLanguage, setSelectedLanguage] = useState();

  const changeLanguage = (lng) => {
    setSelectedLanguage(lng);
    i18n.changeLanguage(lng);
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <div className='text-center font-bold text-[18px] w-full mb-4'>{t('Choose Language')}</div>
        <div className='flex w-full gap-2 items-center justify-center'>
          <button onClick={() => changeLanguage('en')} className={`h-[40px] w-[120px] items-center justify-center p-2 rounded-[12px] border border-rose-500 text-rose-500 hover:bg-rose-500 hover:text-white ${selectedLanguage === 'en' ? 'bg-rose-500 text-white' : ''}`}>English</button>
          <button onClick={() => changeLanguage('sw')} className={`h-[40px] w-[120px] items-center justify-center p-2 rounded-[12px] border border-rose-500 text-rose-500 hover:bg-rose-500 hover:text-white ${selectedLanguage === 'sw' ? 'bg-rose-500 text-white' : ''}`}>Kiswahili</button>
        </div>
        <div className="flex flex-col gap-2 justify-center mt-4">
          <div className='text-center '>{t('Language modal message')}</div>
          <button className="bg-red-500 text-white p-2 rounded" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(LanguageModal);
